import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  AUTH_LOADING,
  AUTH_ERROR
} from '../actions/types';


export const TOKEN_DURATION = 2 * 60 * 60 * 1000;

// Fonction pour vérifier si le token est expiré
const isTokenExpired = (expiresAt) => {
  if (!expiresAt) return true;
  return new Date().getTime() > parseInt(expiresAt, 10);
};

// Lecture des données du localStorage
const storedUser = localStorage.getItem('user');
const storedToken = localStorage.getItem('token');
const storedExpiresAt = localStorage.getItem('expiresAt');

// Vérifie expiration avant tout
if (storedExpiresAt && isTokenExpired(storedExpiresAt)) {
  // Nettoyer si expiré
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('expiresAt');
}

const user = storedUser ? JSON.parse(storedUser) : null;
const token = !isTokenExpired(storedExpiresAt) ? storedToken : null;

const getIsAdmin = (user) => {
  return user && (user.role === 'admin' || user.role === 'superadmin');
};

const initialState = {
  token: token || null,
  isAuthenticated: !!token && !!user,
  user: user || null,
  isAdmin: getIsAdmin(user),
  loading: false,
  error: null
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };

    case LOGIN_SUCCESS:
      // Sauvegarde dans localStorage
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('user', JSON.stringify(action.payload.user));

      return {
        ...state,
        token: action.payload.token,
        isAuthenticated: true,
        user: action.payload.user,
        isAdmin: getIsAdmin(action.payload.user), // ✅ Recalculé ici aussi
        loading: false,
        error: null
      };

    case LOGIN_FAIL:
    case AUTH_ERROR:
      // Nettoyer le localStorage en cas d'erreur
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        user: null,
        isAdmin: false,
        loading: false,
        error: action.payload
      };

    case LOGOUT:
      // Vider le localStorage
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        user: null,
        isAdmin: false,
        loading: false,
        error: null
      };

    default:
      return state;
  }
};

export default authReducer;